import {TranslatedKeyPair} from './TranslatedKeyPair';

export class TranslatedEmb {
keys: {[key: string]: TranslatedKeyPair};
}

